// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.message.type.filter.enums.SatelliteConversationRenterProgressStatusTypeV2

export enum SatelliteConversationRenterProgressStatusTypeV2 {
  APPLICANTS = 'APPLICANTS',
  INQUIRIES = 'INQUIRIES',
  SHOW_ALL = 'SHOW_ALL',
  TENANTS = 'TENANTS',
  TOURS = 'TOURS',
}

export const SatelliteConversationRenterProgressStatusTypeV2_values = [
  SatelliteConversationRenterProgressStatusTypeV2.APPLICANTS,
  SatelliteConversationRenterProgressStatusTypeV2.INQUIRIES,
  SatelliteConversationRenterProgressStatusTypeV2.SHOW_ALL,
  SatelliteConversationRenterProgressStatusTypeV2.TENANTS,
  SatelliteConversationRenterProgressStatusTypeV2.TOURS,
] as const;
